import React, {useEffect} from 'react';
import {Outlet, useNavigate, useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Box, Center, HStack, Stack, useColorMode} from '@chakra-ui/react';
import LanguageBtn from 'components/LanguageBtn';
import ColorModeBtn from 'components/ColorModeBtn';
import {useColorModeValueKey} from 'hooks/useColors';
import Page from 'components/Page';
import {usePlatformBasicInfo} from 'hooks/datahook/auth';
import {useInIframe} from 'hooks/useInIFrame';
import { useSourceRecorder } from 'hooks/useSourceRecorder';

const GuestLayout = (props) => {
    const {center=true} = props
    const {t, i18n} = useTranslation('app');
    const {data: basicInfo, isLoading} = usePlatformBasicInfo();
    const inIframe = useInIframe();
    const {colorMode, setColorMode} = useColorMode();
    const [searchParams] = useSearchParams();
    const defaultColorMode = searchParams.get('colorMode');
    const defaultLang = searchParams.get('lang');
    useSourceRecorder()
    useEffect(() => {
        if (
            defaultColorMode &&
            defaultColorMode !== colorMode &&
            ['light', 'dark'].includes(defaultColorMode)
        ) {
            setColorMode(defaultColorMode);
        }
    }, [defaultColorMode]);

    useEffect(() => {
        if (
            defaultLang &&
            i18n.language !== defaultLang &&
            ['en-US', 'zh-CN', 'zh-TW', 'jp-JP', 'ko-KR'].includes(defaultLang)
        ) {
            i18n.changeLanguage(defaultLang);
        }
    }, [defaultLang]);
    return (
        <Page title={isLoading ? t('loading') : basicInfo.companyShortName}>
            <Box
                position={'relative'}
                width={'100vw'}
                // bg={useColorModeValueKey('bg')}
            >
                {inIframe ? null : (
                    <HStack
                        position={'absolute'}
                        alignItems={'flex-end'}
                        justifyContent={'flex-end'}
                        right={8}
                        top={4}
                        spacing={2}
                        w={'100vw'}
                    >
                        <LanguageBtn />
                        <ColorModeBtn />
                    </HStack>
                )}
                <Stack
                    mx="auto"
                    alignItems={'center'}
                    justifyContent={center?'center':'flex-start'}
                    // position={'absolute'}
                    width={'100vw'}
                    minHeight={'100vh'}
                    // overflow={'scroll'}
                    // bg={useColorModeValueKey('bg')}
                >
                    <Box my={3}>
                        <Outlet />
                    </Box>
                </Stack>
            </Box>
        </Page>
    );
};

export default GuestLayout;
